import TypeToReducer from 'type-to-reducer';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import {
  IMPORT_SET_FILE,
  IMPORT_REMOVE_FILE,
  IMPORT_UPLOAD_FILE,
  IMPORT_PROGRESS_FILE,
  IMPORT_FILE,
  MODIFY_EDITING_IMPORT,
  RESET_IMPORT,
} from 'import/constants';

export const initialState = {
  isImporting: false,
  file: null,
};

export const reducers = {
  [IMPORT_SET_FILE]: (state, { payload }) => ({ ...state, file: payload }),
  [MODIFY_EDITING_IMPORT]: (state, { payload }) => ({ ...state, ...payload }),
  [IMPORT_REMOVE_FILE]: (state) => ({ ...state, file: null }),
  [IMPORT_UPLOAD_FILE]: {
    [PENDING]: (state) => ({
      ...state,
      isImporting: true,
      file: { ...state.file, status: 'files.uploading' },
    }),
    [FULFILLED]: (state) => ({
      ...state,
      isImporting: false,
      file: { ...state.file, status: 'files.uploaded' },
    }),
    [REJECTED]: (state) => ({
      ...state,
      isImporting: false,
      file: { ...state.file, status: 'files.fail' },
    }),
  },
  [IMPORT_PROGRESS_FILE]: (state, { payload }) => ({
    ...state,
    file: { ...state.file, percentage: payload },
  }),
  [IMPORT_FILE]: {
    [PENDING]: (state) => ({
      ...state,
      isImporting: true,
      file: { ...state.file, status: 'files.importing' },
    }),
    [FULFILLED]: (state) => ({
      ...state,
      isImporting: false,
      file: { ...state.file, status: 'files.imported' },
    }),
    [REJECTED]: (state) => ({
      ...state,
      isImporting: false,
      file: { ...state.file, status: 'files.fail' },
    }),
  },
  [RESET_IMPORT]: (state) => ({ ...initialState }),
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/import/reducers/import_form_reducers.js